import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-442fc3b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basePageWraper pagefull" }
const _hoisted_2 = { class: "centerWrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "hero is-link width100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hero-body" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "title has-text-left" }, " 패스워드 변경완료 "),
    /*#__PURE__*/_createElementVNode("p", { class: "subtitle has-text-left" }, " 비밀번호가 변경되었습니다. ")
  ])
], -1))
const _hoisted_4 = { class: "cont" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "info_text" }, [
    /*#__PURE__*/_createTextVNode(" 변경된 비밀번호로 "),
    /*#__PURE__*/_createElementVNode("span", { class: "red" }, "로그인"),
    /*#__PURE__*/_createTextVNode(" 하세요.")
  ])
], -1))
const _hoisted_6 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goto_login && _ctx.goto_login(...args))),
            class: "button"
          }, "로그인 하기")
        ])
      ])
    ])
  ]))
}